import React from 'react';
import { Link } from 'react-router-dom';

const PAKETE = [
  'Leadership-Check — 90 min ehrliche Bestandsaufnahme',
  'Leadership Blueprint — 3 Sessions über 4–6 Wochen',
  'Leadership Sparring — regelmäßige Begleitung im Alltag',
];

function CoachingSection() {
  return (
    <section id="coaching" className="coaching-teaser reveal">
      <div className="coaching-teaser__content">
        <span className="coaching-teaser__badge">1:1 Leadership Coaching</span>
        <h2>Führung lernt man nicht aus Büchern.</h2>
        <p className="coaching-teaser__sub">
          Persönliches Coaching für Teamleiter, Projektleiter und Führungskräfte —
          inklusive kostenlosem Leadership Readiness Check (20 Fragen, sofortiges Ergebnis).
        </p>
        <ul className="coaching-teaser__list">
          {PAKETE.map((p) => <li key={p}>{p}</li>)}
        </ul>
        <Link to="/coaching" className="coaching-teaser__cta">Zum Coaching-Angebot →</Link>
      </div>
    </section>
  );
}

export default CoachingSection;
